import { useEffect, useRef } from 'react';

export function usePageTimeTracking(
    pathname: string,
    onPageStayed?: (stayedPage: string, timeStayedOnPageMs: number) => void,
) {
    const startTimeRef = useRef(0);
    const isInitializedRef = useRef(false);
    const pathnameRef = useRef(pathname);
    pathnameRef.current = pathname;
    const previousPathnameRef = useRef(pathname);
    const onPageStayedRef = useRef(onPageStayed);
    onPageStayedRef.current = onPageStayed;

    // Initialize timer and log stayed event when pathname changes
    useEffect(() => {
        if (!isInitializedRef.current) {
            isInitializedRef.current = true;
            startTimeRef.current = performance.now();
            return;
        }

        const timeOnPreviousPage = performance.now() - startTimeRef.current;
        onPageStayedRef.current?.(previousPathnameRef.current, timeOnPreviousPage);
        startTimeRef.current = performance.now();
        previousPathnameRef.current = pathname;
    }, [pathname]);

    // Log stayed event for current page on beforeunload or unmount
    useEffect(() => {
        const handleBeforeUnload = () => {
            onPageStayedRef.current?.(
                pathnameRef.current,
                performance.now() - startTimeRef.current,
            );
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            onPageStayedRef.current?.(
                pathnameRef.current,
                performance.now() - startTimeRef.current,
            );
        };
    }, []);
}
